import { AssetMasterModule } from "@/store/modules/asset.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const assetManagerMachine = Machine({
    id: "assetManagerMachine",
    context: {
        assetId: null,
        query: null,
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "name",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            always: "assignFilters",
        },
        assignFilters: {
            on: {
                GETTING_ASSET: { target: "gettingAssets", actions: "assignSearchData" },
            },
        },
        gettingAssets: {
            tags: "gettingAssets",
            invoke: {
                id: "gettingAssets",
                src: (context, event) => {
                    return AssetMasterModule.GetAssets(context.searchData);
                },
                onDone: { target: "loadedAssets" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedAssets: {
            on: {
                GETTING_ASSET: { target: "gettingAssets", actions: "assignSearchData" },
                DELETE_ASSET: { target: "deleteAsset", actions: "ispageChanged" },
                ASSIGN_ASSET: { target: "assignAsset", actions: "ispageChanged" },
                REMOVE_ASSIGNED_ASSET: { target: "removeAssignAsset", actions: "ispageChanged" },
                DOWNLOAD_ASSET_EXCEL: { target: "downloadAssetsAsExcel", actions: "assignSearchData" },
            },
        },
        downloadAssetsAsExcel: {
            invoke: {
                id: "downloadAssetsAsExcel",
                src: (context, event) => {
                    return AssetMasterModule.GetAssetsExcel(context.searchData);
                },
                onDone: { target: "loadedAssets" },
                onError: { target: "serviceUnavailable" },
            },
        },
        showRepairAssetOn: {
            invoke: {
                id: "showRepairAssetOn",
                src: (context, event) => {
                    return AssetMasterModule.GetRepairedAssets();
                },
                onDone: { target: "loadedRepairAssets" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedRepairAssets: {
            on: {
                GETTING_ASSET: { target: "gettingAssets", actions: "assignSearchData" },
                DELETE_ASSET: { target: "deleteAsset" },
                DOWNLOAD_ASSET_EXCEL: { target: "downloadAssetsAsExcel", actions: "assignSearchData" },
            },
        },
        deleteAsset: {
            tags: "showDeleteAssetUI",
            on: {
                DELETING_ASSET: { target: "deletingAsset" },
                CANCEL_MODAL: { target: "loadedAssets" },
                CLOSE_MODAL: { target: "loadedAssets" },
            },
        },
        deletingAsset: {
            tags: "showDeleteAssetUI",
            invoke: {
                id: "deletingAsset",
                src: (context, event) => AssetMasterModule.DeleteAssetById(event.assetId),
                onDone: { target: "gettingAssets", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedAssets" },
            },
        },
        assignAsset: {
            on: {
                SEARCH: { actions: "assignDataToSearch", target: "debouncingEmployee" },
                ASSIGNING_ASSET: { target: "assigningAsset" },
                CANCEL_MODAL: { target: "loadedAssets" },
                CLOSE_MODAL: { target: "loadedAssets" },
            },
        },
        debouncingEmployee: {
            on: {
                SEARCH: { actions: "assignDataToSearch", target: "debouncingEmployee" },
            },
            after: {
                1000: {
                    target: "searchEmployee",
                },
            },
        },
        searchEmployee: {
            invoke: {
                id: "searchEmployee",
                src: (context, event) => AssetMasterModule.GetEmployeesByLookup(context.query),
                onDone: { target: "assignAsset" },
                onError: { target: "serviceUnavailable" },
            },
        },
        assigningAsset: {
            invoke: {
                id: "assigningAsset",
                src: (context, event) => AssetMasterModule.AddAssetAssignment(event.payLoad),
                onDone: { target: "gettingAssets", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        removeAssignAsset: {
            tags: "showRemovingAssetUI",
            on: {
                REMOVING_ASSIGNING_ASSET: { target: "removingAssignAsset" },
                CANCEL_MODAL: { target: "loadedAssets" },
                CLOSE_MODAL: { target: "loadedAssets" },
            },
        },
        removingAssignAsset: {
            tags: "showRemovingAssetUI",
            invoke: {
                id: "assigningAsset",
                src: (context, event) => AssetMasterModule.RemoveAssetAssignment(event.assetId),
                onDone: { target: "gettingAssets", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignDataToSearch: assign({
            query: (context, event) => event.str,
        }),
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    if (context.ispageChanged) {
                        const updatedSearchData = {
                            ...context.searchData,
                            page: context.searchData.page - 1,
                        };
                        AssetMasterModule.AssignSearchParams(updatedSearchData);
                        return updatedSearchData;
                    }
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default assetManagerMachine;
